import React from "react";

function SuperE3() {
  return (
    <div>
      <p>
        We’d all love to know that our loved ones are financially secure in the
        event that anything happens to us. Super E Plus helps feel confident
        that their needs will be catered for. How does it help you protect their
        future?
      </p>
      <div className="my-4">
      <ul className="list-disc list-inside">
      <li>Super E Plus comes with a life insurance policy equal to the sum assured.</li>
      <li>In the event you contract any critical illness covered by the policy for example cancer, stroke or a heart attack, Britam pays 50% of the sum assured immediately. Also, you will be exempted from paying all future premi ums as Britam will make them for you. Bonuses and lump sum payments will also be paid when they fall due.</li>
      <li>If the insured passes on accidentally, Britam pays 100% of the sum assured and waives all the other premiums required as Britam makes the payments for you. Also, bonuses and lump sum payments will also be paid when they fall due.</li>
      <li>IIf you are unable to pay the premiums due to a disability, accident or illness, all the future premiums will be paid by Britam. Also, all unpaid bonuses and maturity benefits will be paid when they fall due.</li>

      </ul>
      </div>
    </div>
  );
}

export default SuperE3;
